import React from 'react';
import { TID } from '@/constants/testIds';
import { selectors } from '@/engine/engine';

function CardLine({ label, value }) {
  return (
    <div className="flex justify-between text-xs font-mono">
      <span className="text-white/60">{label}</span>
      <span className="text-white">{value}</span>
    </div>
  );
}

export default function DevPanel({ state, onAction, onClose, onToggleReveal, reveal }) {
  return (
    <div data-testid={TID.devPanel} className="absolute inset-0 z-50 bg-black/90 overflow-y-auto px-4 py-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-3xl text-[hsl(var(--k-gold))]">Dev Mode</h2>
        <button data-testid={TID.devClose} className="btn-ghost" onClick={onClose}>Close</button>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-5">
        <button data-testid={TID.devForceJoker} className="btn-secondary" onClick={() => onAction({ type: 'DEV_SPAWN_JOKER' })}>+ Joker</button>
        <button data-testid={TID.devForcePenalty} className="btn-secondary" onClick={() => onAction({ type: 'DEV_FORCE_PENALTY' })}>Penalty</button>
        <button data-testid="dev-force-halftime-btn" className="btn-secondary" onClick={() => onAction({ type: 'DEV_FORCE_HALFTIME' })}>Halftime</button>
        <button data-testid={TID.devRestart} className="btn-secondary" onClick={() => onAction({ type: 'DEV_RESTART' })}>Restart</button>
        <button data-testid={TID.devRevealAll} className="btn-secondary" onClick={onToggleReveal}>{reveal ? 'Hide All' : 'Reveal All'}</button>
      </div>

      <div className="text-white/70 text-xs font-mono mb-3 flex justify-between">
        <span>Half {state.half}/2</span>
        <span>1st starter: {state.firstHalfStarter}</span>
      </div>

      <div data-testid={TID.debugInspector} className="bg-[hsl(var(--k-bg-elev))] rounded-lg p-3 border border-[hsl(var(--k-line))]">
        <div className="font-heading text-lg text-[hsl(var(--k-gold))] mb-2">Inspector</div>
        <CardLine label="Phase" value={state.phase} />
        <CardLine label="Turn" value={state.turnNumber} />
        <CardLine label="Current" value={state.currentPlayer} />
        <CardLine label="Deck Remaining" value={selectors.remainingCards(state)} />
        <CardLine label="Discard" value={state.discard.length} />
        <CardLine label="Total Cards" value={selectors.totalCards(state)} />
        <CardLine label="Drawn" value={state.drawnCard ? `${state.drawnCard.rank} ${state.drawnCard.suit}` : '—'} />
        <CardLine label="P1 Score" value={state.players.p1.score} />
        <CardLine label="P2 Score" value={state.players.p2.score} />
        <CardLine label="P1 GK" value={state.players.p1.goalkeeper ? `${state.players.p1.goalkeeper.rank}${state.players.p1.goalkeeper.suit[0]}` : '—'} />
        <CardLine label="P2 GK" value={state.players.p2.goalkeeper ? `${state.players.p2.goalkeeper.rank}${state.players.p2.goalkeeper.suit[0]}` : '—'} />
        <CardLine label="P1 Atk" value={state.players.p1.attacks.map((c) => c ? `${c.rank}${c.suit[0]}` : '_').join(' ')} />
        <CardLine label="P2 Atk" value={state.players.p2.attacks.map((c) => c ? `${c.rank}${c.suit[0]}` : '_').join(' ')} />
        <CardLine label="P1 Def" value={state.players.p1.defenses.map((c) => c ? `${c.rank}${c.suit[0]}` : '_').join(' ')} />
        <CardLine label="P2 Def" value={state.players.p2.defenses.map((c) => c ? `${c.rank}${c.suit[0]}` : '_').join(' ')} />
        <div className="mt-3">
          <div className="text-white/60 text-xs font-mono">Top of deck (next 6):</div>
          <div className="text-white text-xs font-mono break-words">
            {state.deck.slice(0, 6).map((c) => `${c.rank}${c.suit[0]}`).join(' · ')}
          </div>
        </div>
      </div>
    </div>
  );
}
